// const tab__hdng = document.querySelectorAll(".cust_platform_metaWrap .tab__hdngs .tab__hdng");
// const tab__cntnt = document.querySelectorAll(".cust_platform_metaWrap .tab__cntnts .tab__cntnt");

// tab__hdng[0].classList.add("active");
// tab__cntnt[0].classList.add("active");

// tab__hdng.forEach((item, index) => {
//   item.addEventListener("click", () => {
//     console.log("clicked");
//     tab__hdng.forEach(tab => tab.classList.remove("active"));
//     tab__cntnt.forEach(content => content.classList.remove("active"));

//     // Activate the clicked tab and corresponding content
//     item.classList.add("active");
//     tab__cntnt[index].classList.add("active");

//     let resultOfselection =  item.innerText.trim() == 'E-book' ? true : false
//     console.log(resultOfselection)
//   });
// });


// Read sample pop-up
document.addEventListener("DOMContentLoaded", function () {
  const popUpButtons = document.querySelectorAll(".openPop");
  const body = document.body;

  popUpButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const wrapper = btn.closest(".img_sampleWrap") || btn.closest(".audio_sampleWrap");

      if (!wrapper) return;

      const overlay = wrapper.querySelector(".popOverlay");
      const container = wrapper.querySelector(".popContainer");
      const closeBtn = wrapper.querySelector(".closeBtn");

      overlay?.classList.add("active");
      container?.classList.add("active");
      body.classList.add("noScroll");

      const closePopup = () => {
        overlay?.classList.remove("active");
        container?.classList.remove("active");
        body.classList.remove("noScroll");

        // If there's an audio, pause it
        const audio = container?.querySelector("audio");
        if (audio) {
          audio.pause();
          audio.currentTime = 0;
        }
      };

      overlay?.addEventListener("click", closePopup);
      closeBtn?.addEventListener("click", closePopup);
    });
  });
});
// Read sample pop-up

// Custom button to play audio
  const audioWrap = document.querySelector(".audio_sampleWrap");
  const audioBtn = audioWrap.querySelector(".audio_sampleBtn");
  const audio = audioWrap.querySelector(".sample_audio");
  
  const iconPlay = audioBtn.querySelector(".icon_play");
  const iconPause = audioBtn.querySelector(".icon_pause");
  
  audioBtn.addEventListener("click", function () {
    if (audio.paused) {
      audio.play();
      iconPlay.style.display = "none";
      iconPause.style.display = "inline-block";
    } else {
      audio.pause();
      iconPlay.style.display = "inline-block";
      iconPause.style.display = "none";
    }
  });
  
  // Optional: reset icon when audio ends
  audio.addEventListener("ended", function () {
    iconPlay.style.display = "inline-block";
    iconPause.style.display = "none";
  });
// Custom button to play audio

// Accordion
document.querySelectorAll(".cust_platform_metaWrap .platform_content").forEach((accordion_item) => {
  const accordion_title = accordion_item.querySelector(".platform_heading");
  const accordion_content = accordion_item.querySelector(".platform_contents");

  if (accordion_item && accordion_content && accordion_title) {
    accordion_title.addEventListener("click", () => {
      const allItems = document.querySelectorAll(".cust_platform_metaWrap .platform_content");

      // If clicked item is already open, close it
      if (accordion_item.classList.contains("open")) {
        accordion_item.classList.remove("open");
        accordion_content.style.maxHeight = "0px";
        return;
      }

      // Close all other accordions
      allItems.forEach((item) => {
        const content = item.querySelector(".platform_contents");
        item.classList.remove("open");
        if (content) content.style.maxHeight = "0px";
      });

      // Open the clicked accordion
      accordion_item.classList.add("open");
      accordion_content.style.maxHeight = accordion_content.scrollHeight + "px";
    });
  }
});

// Accordion